// Part of salesPages, split by screen to keep files short; ../salesPages.ts merges the parts.
// Keys sit directly under salesPages, in sub-objects whose names no other part uses.
export const en = {
  projectList: {
    title: 'Projects',
    description: 'Income and costs of each piece of work for a customer, straight from the books.',
    newProject: 'New project',
    off: 'Projects are off, so forms do not show them. Switch them on in Company settings › Advanced › Projects.',
    searchLabel: 'Search projects',
    searchPlaceholder: 'Search by project or customer',
    loadError: 'Could not load projects',
    empty: 'No projects here',
    emptyHint: 'A project tracks income and costs for one customer.',
    colProject: 'Project',
    colCustomer: 'Customer',
    colStartDate: 'Start date',
    colEndDate: 'End date',
    reopen: 'Reopen',
    markCompleted: 'Mark completed',
    markCancelled: 'Mark cancelled',
    delete: 'Delete',
    deleted: 'Project "{{name}}" deleted.',
  },
  inventoryAdjustProblems: {
    account: 'Choose the inventory adjustment account.',
    noProduct: 'Add at least one product.',
    eachProduct: 'each product',
    quantity: 'Enter the new quantity of {{name}}.',
    twice: '{{name}} is on the adjustment twice.',
  },
};

export const ar = {
  projectList: {
    title: 'المشاريع',
    description: 'إيرادات وتكاليف كل عمل يُنجز لعميل، مأخوذة مباشرة من الدفاتر.',
    newProject: 'مشروع جديد',
    off: 'المشاريع متوقفة، لذا لا تظهر في النماذج. فعّلها من إعدادات الشركة › خيارات متقدمة › المشاريع.',
    searchLabel: 'البحث في المشاريع',
    searchPlaceholder: 'ابحث باسم المشروع أو العميل',
    loadError: 'تعذر تحميل المشاريع',
    empty: 'لا توجد مشاريع هنا',
    emptyHint: 'يتتبع المشروع الإيرادات والتكاليف لعميل واحد.',
    colProject: 'المشروع',
    colCustomer: 'العميل',
    colStartDate: 'تاريخ البدء',
    colEndDate: 'تاريخ الانتهاء',
    reopen: 'إعادة فتح',
    markCompleted: 'تعليم كمكتمل',
    markCancelled: 'تعليم كملغى',
    delete: 'حذف',
    deleted: 'تم حذف المشروع "{{name}}".',
  },
  inventoryAdjustProblems: {
    account: 'اختر حساب تسوية المخزون.',
    noProduct: 'أضف منتجًا واحدًا على الأقل.',
    eachProduct: 'كل منتج',
    quantity: 'أدخل الكمية الجديدة لـ {{name}}.',
    twice: '{{name}} مذكور في التسوية مرتين.',
  },
};
